import React, { useRef,useState } from 'react';
import './index.less';
import img from '@/assets/home/address.png';
import img2 from '@/assets/home/email.png';
import img_bg from '@/assets/home/bottom.png';

const  BottomPage =()=> {

    return (  
      <div className='bottom_page'>
           <div className="img_top"><img src={img_bg} alt="" /></div>
           <div className="contact_us">
              <div className="cube">
                 <div className="img"><img src={img} alt="" /></div>
                 <div className="data">
                    <h3>Visit Office</h3>
                    <p>VO3-10-23A, SUNWAY VELOCITY DESIGNER OFFICE LINGKARAN SVSUNWAY VELOCITY, JALAN COCHRANE 55100 KUALA LUMPUR W.PKUALA LUMPUR MALAYSIA</p>
                 </div>
              </div>
              <div className="cube">
                 <div className="img"><img src={img2} alt="" /></div>
                 <div className="data">
                    <h3>Email Us</h3>
                    <p>contact@electron-gateway.ltd</p>
                 </div>
              </div>
           </div>
      </div>  
    );  
}
  
export default  BottomPage;